import Store from "../Store";
import { currentILTActionsSliceActions } from "../Store/Slices/CurrentILTActions";
let audioObj = new Audio();
let audioObj1 = new Audio();
let initTimeOut = null;

export const CheckActions = (items, from = null) => {
  switch (items.action) {
    case "showContent":
      showContent(items.source, items.referances, from);
      break;
    case "hideContent":
      hideContent(items.source, items.referances, from);
      break;
    case "audPlay":
      audPlay(items.source, items.referances, from);
      break;
    case "showChat":
      showChat(items.source, items.referances);
      break;
    case "hideChat":
      hideChat(items.source, items.referances);
      break;
  }
};

export const showContent = (src, refs,from) => {
  refs.forEach((id, index) => {
    if (document.getElementById(id)) {
      if(from == 'notSvg'){
        document.getElementById(id).style.display = "inline-flex";
      }
      else{
        document.getElementById(id).setAttribute('display','inline-flex');
      }
    }
  });
};

export const hideContent = (src, refs,from) => {
  refs.forEach((id, index) => {
    if (document.getElementById(id)) {
      if(from == 'notSvg'){
        document.getElementById(id).style.display = "none";
      }
      else{
        document.getElementById(id).setAttribute('display','none');
      }
      //document.getElementById(id).style.display = "none";
    }
  });
};

export const audPlay = (src, refs, from) => {
  if (!from) {
    audioObj1.pause();
    audioObj.pause();
    Store.dispatch(currentILTActionsSliceActions.setAudioStatusInit(false));
    audioObj.src = `${sessionStorage.getItem("media_url")}audio/${src}`;
    audioObj.play();
    Store.dispatch(currentILTActionsSliceActions.setAudioStatus(true));
    audioObj.onended = () => {
      Store.dispatch(currentILTActionsSliceActions.setAudioStatus(false));
    };
  } else {
    clearTimeout(initTimeOut);
    initTimeOut = setTimeout(() => {
      audioObj1.pause();
      audioObj.pause();
      Store.dispatch(currentILTActionsSliceActions.setAudioStatus(false));
      audioObj1.src = `${sessionStorage.getItem("media_url")}audio/${src}`;
      audioObj1.play();
      Store.dispatch(currentILTActionsSliceActions.setAudioStatusInit(true));
      audioObj1.onended = () => {
        Store.dispatch(currentILTActionsSliceActions.setAudioStatusInit(false));
      };
    }, 1000);
  }
};

export const showChat = (src, refs) => {
  if (document.getElementById("text")) {
    document.getElementById("text").style.display = "none";
  }
  if (document.getElementById("alttext")) {
    document.getElementById("alttext").style.display = "block";
  }
};

export const hideChat = (src, refs) => {
  if (document.getElementById("alttext")) {
    document.getElementById("alttext").style.display = "none";
  }
  if (document.getElementById("text")) {
    document.getElementById("text").style.display = "block";
  }
};

export const resetAudio = (toggle = false) => {
  audioObj1.pause();
  clearTimeout(initTimeOut);
  Store.dispatch(currentILTActionsSliceActions.setAudioStatusInit(false));
  if (toggle && audioObj.paused) {
    audioObj.play();
    Store.dispatch(currentILTActionsSliceActions.setAudioStatus(true));
  } else {
    audioObj.pause();
    Store.dispatch(currentILTActionsSliceActions.setAudioStatus(false));
  }
};

export const initAudioReset = (toggle = false) => {
  audioObj.pause();
  Store.dispatch(currentILTActionsSliceActions.setAudioStatus(false));
  if (toggle && audioObj1.paused) {
    audioObj1.play();
    Store.dispatch(currentILTActionsSliceActions.setAudioStatusInit(true));
  } else {
    audioObj1.pause();
    Store.dispatch(currentILTActionsSliceActions.setAudioStatusInit(false));
  }
};
